<template lang="pug">
  collapsed-data-sections(:sections="[lvl2]")
</template>
<script>
import record from '../../constants/tooltips/record'
import CollapsedDataSections from '@/components/record-details/CollapsedDataSections'

export default {
  components: {
    CollapsedDataSections,
  },
  data () {
    return {
      lvl2: {
        title: 'Fund Relationships',
        property: 'showLevelTwoFunds',
        tableLayout: 'rel-lvl-2',
        tip: record.l2Funds,
        data: [],
      },
    }
  },
}
</script>
<style lang="stylus" scoped>
@import "../../assets/styles/variables.styl"
</style>



// WEBPACK FOOTER //
// src/components/record-details/RecordInfoLvl2Funds.vue